<template>
  <div>
    <base-alert v-model="alertVisible" variant="success" :time="2">Pruebas</base-alert>
    <b-container class="pt-5">
      <b-row class="vh-100 mx-auto text-center" align-v="center">
        <base-birthdate-input v-model="birthDate"></base-birthdate-input>
				<button @click="throwError">Throw error</button>
        <span>{{ birthDate }}</span>
        <!-- <b-col cols="12">
        <b-row>
          <b-button variant="primary" @click="showDialog">Mostrar dialog</b-button>
          <b-button variant="secondary">Profesional</b-button>
          <b-button variant="danger">Volver a intentar</b-button>
          <b-button variant="info" @click="showDialog">Volver</b-button>
          <b-button variant="success">Aceptar consulta</b-button>
          <b-button variant="warning">Aceptar consulta</b-button>
        </b-row>
        <b-row class="mt-4">
          <b-button variant="outline-primary" @click="showDialog">Continuar</b-button>
          <b-button variant="outline-danger">Volver a intentar</b-button>
          <b-button variant="outline-info" @click="showDialog">Volver</b-button>
          <b-button variant="outline-success">Aceptar consulta</b-button>
          <b-button variant="outline-warning">Aceptar consulta</b-button>
        </b-row>
      </b-col>-->
        <b-col cols="12">
          Base buttons
          <b-row>
            <base-button blue @click="showDialog">Mostrar dialog</base-button>
            <base-button white shadow @click="$helpers.goToWebApp('HomePaciente/#/appointments/review/')">Prueba webapp</base-button>
            <base-button red>Volver a intentar</base-button>
            <base-button gray @click="showDialog">Volver</base-button>
            <!-- <b-button variant="success">Aceptar consulta</b-button>
          <b-button variant="warning">Aceptar consulta</b-button> -->
          </b-row>
          <b-row class="mt-4">
            <base-button blue outline @click="showDialog">Continuar</base-button>
            <base-button red outline>Volver a intentar</base-button>
            <base-button gray outline @click="showDialog">Volver</base-button>
            <!-- <b-button variant="outline-success">Aceptar consulta</b-button>
          <b-button variant="outline-warning">Aceptar consulta</b-button> -->
          </b-row>
        </b-col>
        <b-col cols="12">
          Bootstrap B-tabs
          <b-tabs fill>
            <b-tab title="Mi perfil" :active="activeTab == 'profile'">
              Mi perfil
            </b-tab>
            <b-tab title="Mis servicios" :active="activeTab == 'services'">
              Mis servicios
            </b-tab>
            <b-tab title="Chats" :active="activeTab == 'chats'">
              Chats
            </b-tab>
            <b-tab title="Mis consultas" :active="activeTab == 'appointments'">
              Mis consultas
            </b-tab>
            <b-tab title="Solicitudes de cita (1)" :active="activeTab == 'requests'">
              Solicitudes de cita (1)
            </b-tab>
            <b-tab title="Mi agenda" :active="activeTab == 'scheduler'">
              Mi agenda
            </b-tab>
            <b-tab title="Mis pacientes" :active="activeTab == 'patients'">
              Mis pacientes
            </b-tab>
          </b-tabs>
        </b-col>
        <b-col cols="12">
          Base Radio Group
          <base-radio-group :options="radioGroup.options" v-model="radioGroup.selected"></base-radio-group>
        </b-col>
        <b-col cols="12">
          Binary Radio Group
          <binary-radio-group v-model="binRadioGroup.selected"></binary-radio-group>
        </b-col>
        <b-col cols="12">
          Switches
          <b-form-checkbox v-model="switchObj.selected" switch>
            <img class="nav-item-icon" src="/static-appopensalud/img/icons/stethoscope-gray.svg" />{{$t('enable-stethoscope')}}
          </b-form-checkbox>
        </b-col>
        <!-- <b-col cols="12">
        <b-form-select v-model="formSelect.selected" :options="formSelect.options" placeholder="Bootstrap Vue Form Select"></b-form-select>
      </b-col> -->
        <b-col cols="12">
          Base Select
          <base-select v-model="formSelect.selected" label="text" :options="formSelect.options"
            :dataAttributes="[{ key: 'paytpv', value: 'prueba'}]"></base-select>
          <base-select v-model="formSelect.selected" label="text" :options="formSelect.options" valueProp="customValue">
          </base-select>
        </b-col>
        <b-col cols="12">
          Highcharts
          <highcharts :options="chartOptions"></highcharts>
        </b-col>
        <b-col cols="12">
          <b-button variant="primary" @click="consolidateAppointmentModal.visible = true">Modal consolidación de
            consulta</b-button>
          <consolidate-appointment-modal v-model="consolidateAppointmentModal.visible"
            :isBillable="consolidateAppointmentModal.isBillable" @consolidate="onConsolidate">
          </consolidate-appointment-modal>
        </b-col>
      </b-row>
      <base-dialog v-model="dialogVisible" :okFn="okFn" :cancelFn="cancelFn"
        content="¿Está seguro de que desea continuar?"></base-dialog>
      <stethoscope-modal ref="stethoscopeModal"></stethoscope-modal>
    </b-container>
  </div>
</template>

<script>
import { BContainer, BRow, BButton, BTabs, BTab, BFormGroup, BFormCheckbox, BFormRadio, BCol, BFormSelect, BAlert } from 'bootstrap-vue'
import { Chart } from 'highcharts-vue'
import StethoscopeModal from '@/components/video-launcher/StethoscopeModal'
import BaseAlert from '@/components/base/ui/BaseAlert'
import BaseBirthdateInput from '@/components/base/forms/BaseBirthdateInput'

export default {
  components: {
    'base-dialog': () => import('@/components/base/BaseDialog'),
    BContainer,
    BCol,
    BRow,
    BButton,
    BTabs,
    BTab,
    BFormGroup,
    BFormCheckbox,
    BFormRadio,
    BFormSelect,
    highcharts: Chart,
    'base-select': () => import('@/components/base/forms/BaseSelect.vue'),
    'base-radio-group': () => import('@/components/base/forms/BaseRadioGroup.vue'),
    'binary-radio-group': () => import('@/components/base/forms/BinaryRadioGroup.vue'),
    'base-button': () => import('@/components/base/buttons/BaseButton.vue'),
    'consolidate-appointment-modal': () => import('@/components/webapp/shared/ConsolidateAppointmentModal.vue'),
    StethoscopeModal,
    BAlert,
    BaseAlert,
    BaseBirthdateInput
  },
  data () {
    return {
      birthDate: null,
      alertVisible: true,
      formSelect: {
        selected: { value: 'a', text: 'This is First option' },
        options: [
          { value: null, text: 'Please select an option' },
          { value: 'a', text: 'This is First option' },
          { value: 'b', text: 'Selected Option' },
          { value: { C: '3PO' }, text: 'This is an option with object value' },
          { value: 'd', text: 'This one is disabled', disabled: true }
        ],
        options2: [
          { customValue: null, text: 'Please select an option' },
          { customValue: 'a', text: 'This is First option' },
          { customValue: 'b', text: 'Selected Option' },
          { customValue: { C: '3PO' }, text: 'This is an option with object value' },
          { customValue: 'd', text: 'This one is disabled', disabled: true }
        ]
      },
      radioGroup: {
        options: [
          { value: true, text: 'Sí' },
          { value: false, text: 'No' }
        ],
        selected: null
      },
      binRadioGroup: {
        selected: null
      },
      genderOptions: [
        { value: true, text: 'Yes' },
        { value: false, text: 'No' }
      ],
      activeTab: 'services',
      dialogVisible: false,
      chartOptions: {
        title: {
          text: 'Video'
        },
        credits: false,
        plotOptions: {
          series: {
            lineWidth: 2,
            marker: {
              enabled: true
            }
          }
        },
        yAxis: {
          floor: 0,
          title: {
            text: 'bitrate'
          }
        },
        chart: {
          height: 400,
          type: 'spline',
          renderTo: 'video-meter',
          styledMode: true
        },
        legend: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },
        series: [{
            name: 'Installation',
            data: [43934, 52503, 57177, 69658, 97031, 119931, 137133, 154175]
        }, {
            name: 'Manufacturing',
            data: [24916, 24064, 29742, 29851, 32490, 30282, 38121, 40434]
        }, {
            name: 'Sales & Distribution',
            data: [11744, 17722, 16005, 19771, 20185, 24377, 32147, 39387]
        }, {
            name: 'Project Development',
            data: [null, null, 7988, 12169, 15112, 22452, 34400, 34227]
        }, {
            name: 'Other',
            data: [12908, 5948, 8105, 11248, 8989, 11816, 18274, 18111]
        }]
      },
      consolidateAppointmentModal: {
        visible: false,
        selectedBillableEntity: null,
        isBillable: true,
        billableEntities: [
          { value: 'entity1', text: 'Javier Pallarés Saavedra' },
          { value: 'entity2', text: 'Centro Médico Sual' }
        ]
      },
      switchObj: {
        selected: false
      }
    }
  },
  methods: {
    okFn () {
      alert('Okey pulsado')
    },
    cancelFn () {
      alert('Cancel pulsado')
    },
    showDialog () {
      this.dialogVisible = true
    },
    radioValueChanged (value) {
      this.radioGroup.selected = value
    },
    onConsolidate (billableEntity, noCharge) {
      this.consolidateAppointmentModal.selectedBillableEntity = billableEntity
      this.consolidateAppointmentModal.noCharge = noCharge
    },
		throwError () {
      throw new Error('Sentry Error test')
    }
  },
  mounted () {
    this.$refs.stethoscopeModal.showModal = true
  }
}
</script>

<style lang="scss">
  @import '../../../../static-appopensalud/css/vendor/custom_highcharts.scss';

  .btn {
    margin: 1.5rem;
  }

  .nav-item-icon {
    margin-right: 10px;
    width: 23px;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/testing/ComponentTesting.vue